import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { User } from '@data/models/user';
import { ProfileService } from '@data/services/profile.service';
import { CurrentProfile } from '@data/models/currentprofile';
import { LocalStorageService } from '../services/local-storage.service';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '@env/environment';
import { SpinnerService } from '@core/services/spinner.service';


@Injectable()
export class AuthService {
  currentProfile: CurrentProfile;
  keyCloakObj: any;
  contactId: string;
  photoUrl = 'assets/img/Default_Profile_Img.png';
  loading = false;

  constructor(
    private http: HttpClient,
    private profile: ProfileService,
    private localStorageService: LocalStorageService,
    private router: Router, protected readonly keycloak: KeycloakService,
  private spinner: SpinnerService) { }

  public isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    const session = localStorage.getItem('session');
    if (token && session) {
      return true;
    } else {
      return false;
    }
  }

  public keycloakInit(keycloak: KeycloakService) {
    return () =>
      keycloak.init({
        config: environment.keycloakConfig,
        initOptions: {
          onLoad: 'login-required',
          silentCheckSsoRedirectUri:
            window.location.origin + '/assets/silent-check-sso.html',
        },
      });
  }

  /**
   * This function used to fetch the user info and creates a session through local Storage service.
   * @author Avesh Srivastava
   * @createdOn Oct-20-2020
   */
  setUserSession() {
    this.loading = true;
    this.keyCloakObj = this.keycloak;
    if (this.keyCloakObj) {

      if (this.keyCloakObj._userProfile.attributes.contactId
        && this.keyCloakObj._userProfile.attributes.contactId.length > 0
        ) {
        this.contactId = this.keyCloakObj._userProfile.attributes.contactId[0];
      }
      if (this.keyCloakObj._userProfile.attributes.photoUrl
        && this.keyCloakObj._userProfile.attributes.photoUrl.length > 0
        && this.keyCloakObj._userProfile.attributes.photoUrl[0] !== ''
        ) {
        this.photoUrl = this.keyCloakObj._userProfile.attributes.photoUrl[0];
      }

    if (this.contactId && this.contactId !== '') {
      let userDetails = {
        UID: this.keyCloakObj._instance.subject,
        contactId: this.contactId,
        thumbnailURL: this.photoUrl,
        photoURL: this.photoUrl,
        email: this.keyCloakObj._userProfile.email,
        firstName: this.keyCloakObj._userProfile.firstName,
        lastName: this.keyCloakObj._userProfile.lastName,
        loginProvider: 'site',
        signatureTimestamp: this.keyCloakObj._instance.idTokenParsed.auth_time,
        UIDSignature: '',
        newUser: false,
        keepmelogin: false,
        source: 'EventManagement'
      };
      if (this.keyCloakObj._instance.idTokenParsed.identity_provider) {
        userDetails.loginProvider = this.keyCloakObj._instance.idTokenParsed.identity_provider;
      }
      localStorage.setItem('loginProvider', userDetails.loginProvider);
      this.profile.currentProfile = new User();
      this.profile.profileUpdate();
      this.profile.socialLogin(userDetails).subscribe((result: any) => {
        if (result) {
          this.localStorageService.setToken(result);
          this.loading = false;
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
      });
    } else {
    if (this.keyCloakObj._userProfile.attributes.day){
      let userData = {
        data: {
          "regUserObj":{
            "firstName":this.keyCloakObj._userProfile.firstName,
            "lastName": this.keyCloakObj._userProfile.lastName,
            "email": this.keyCloakObj._userProfile.email,  
            "country": "United States",
            "date": this.keyCloakObj._userProfile.attributes.day,
            "year": this.keyCloakObj._userProfile.attributes.year,
            "month": this.keyCloakObj._userProfile.attributes.month,
          }
        }
      };
        //if email ID is NOT present in the mongodb.
        this.profile.registration(userData).subscribe((res: any) => {
          this.loading = false;
          location.reload();
      },(error:HttpErrorResponse)=>{
      })
    } 
    }
    }
    this.loading = false;
  }

  getToken() {
    return localStorage.getItem('token');
  }

  logout() {
    localStorage.setItem('session', '');
    localStorage.setItem('token', '');
    return true;
  }

}
